import { trackInhouseEvent } from '@/features/analytics/in-house'

import { eventBus } from '../bus'
import { convertToFavoriteData, userExperiments } from '../utils'

function trackInternalEvent(eventName: string, payload: object) {
    if (typeof window === 'undefined') return

    trackInhouseEvent({
        event: eventName,
        ...userExperiments(),
        ...payload,
    })
}

export function registerInternalSubscribers(events: Set<string>) {
    if (events.has('seo_description_show_more_debug')) {
        eventBus.subscribe('seo_description.show_more_clicked', (payload) => {
            trackInternalEvent('seo_description_show_more_debug', { version: 'internal', ...payload })
        })
    }

    if (events.has('add_to_favorite_debug')) {
        eventBus.subscribe('favorite.added', (payload) => {
            const data = convertToFavoriteData(payload)
            trackInternalEvent('add_to_favorite_debug', data)
        })
    }

    if (events.has('remove_from_favorite_debug')) {
        eventBus.subscribe('favorite.removed', (payload) => {
            const data = convertToFavoriteData(payload)
            trackInternalEvent('remove_from_favorite_debug', data)
        })
    }
}
